import InsightsCard from '../components/InsightsCard';
import { useBlogs } from '../../components/context/BlogContext';
import NoContent from '../../components/common/NoContent';
import Loading from '../../components/common/Loading';

const LPSectionBlogs = () => {
  const { blogs, isLoading } = useBlogs();

  if (isLoading) return <Loading />;
  if (!blogs || blogs.length === 0) {
    return <NoContent title="No Blog Found" description="" />;
  }

  const insightsData = blogs.map((blog,i) => ({
    id: blog.id,
    category: blog.tags?.[0] || 'Insight',
    title: blog.heading,
    description: blog.blogDescription?.[0]?.description?.[0] || '',
    image: blog.Image?.url || '',
    link: `/blog/${blog.slug}`,
    index: i,
  }));

  

  return (
    <div className='mb-12'>
      <div className="flex justify-center items-center pt-14 mb-[60px]">
        <h2 className="text-[34.84px] leading-[100%] font-semibold text-center align-middle text-[#C0C0C0] font-inter">AI and Us</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {insightsData.splice(0,3).map((insight) => (
          <InsightsCard key={insight.id} {...insight} />
        ))}
      </div>
    </div>
  );
};

export default LPSectionBlogs;
